"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Backdrop = void 0;
var Accelerator_1 = __importDefault(require("../Router/Accelerator"));
/**
 * Handles a single backdrop you can use in multiple locations.
 *
 * The backdrop is set as last child in the DOM and bound to that div element.
 *
 * To use the backdrop you can instantiate it where you need it. This class is a singleton so it only gets created once.
 *
 * @example ```html
 * <div class="wr-backdrop custom-backdrop backdrop" open>
 * ```
 */
var Backdrop = /** @class */ (function () {
    function Backdrop() {
        this.on = function () {
        };
        this.fire = function () {
        };
        if (Backdrop._instance) {
            return Backdrop._instance;
        }
        if (!this.doesBackdropExist()) {
            this.createBackdrop();
        }
        this.accelerator = new Accelerator_1.default();
        this.on = this.accelerator.subscribe.bind(this.accelerator);
        this.fire = this.accelerator.publish.bind(this.accelerator);
        this.backdrop = document.querySelector('.wr-backdrop');
        this.addEventListeners();
        Backdrop._instance = this;
    }
    Backdrop.prototype.addEventListeners = function () {
        var _this = this;
        this.backdrop.addEventListener('click', this.clickHandler.bind(this));
        document.addEventListener('keydown', this.keyPressHandler.bind(this));
        /**
         * @deprecated 1.0.0 The global events are deprecated in preference of PubSub system.
         */
        this.backdrop.addEventListener('wr-backdrop-show', function () { return _this.fire('show'); });
        /**
         * @deprecated 1.0.0 The global events are deprecated in preference of PubSub system.
         */
        document.body.addEventListener('wr-backdrop-show', function () { return _this.fire('show'); });
        /**
         * @deprecated 1.0.0 The global events are deprecated in preference of PubSub system.
         */
        this.backdrop.addEventListener('wr-backdrop-hide', function () { return _this.fire('hide'); });
        /**
         * @deprecated 1.0.0 The global events are deprecated in preference of PubSub system.
         */
        document.body.addEventListener('wr-backdrop-hide', function () { return _this.fire('hide'); });
        this.on('close', this.hideBackdrop.bind(this));
        this.on('hide', this.hideBackdrop.bind(this));
        this.on('open', this.showBackdrop.bind(this));
        this.on('show', this.showBackdrop.bind(this));
    };
    Backdrop.prototype.doesBackdropExist = function () {
        return !!document.querySelector('.wr-backdrop');
    };
    Backdrop.prototype.isBackdropVisible = function () {
        return this.backdrop.classList.contains('show') ||
            (this.backdrop.hasAttribute('open') && this.backdrop.getAttribute('open') === 'true');
    };
    Backdrop.prototype.createBackdrop = function () {
        var div = document.createElement('div');
        div.classList.add('wr-backdrop', 'custom-backdrop', 'backdrop');
        document.body.appendChild(div);
        this.fire('backdrop-created', { element: div, backdrop: this });
    };
    Backdrop.prototype.showBackdrop = function () {
        if (this.isBackdropVisible()) {
            return;
        }
        this.backdrop.classList.remove('hidden');
        this.backdrop.classList.add('show');
        this.backdrop.setAttribute('open', 'true');
        document.body.dispatchEvent(new CustomEvent('wr-backdrop-shown', {
            detail: {
                element: this.backdrop,
                backdrop: this
            }
        }));
    };
    Backdrop.prototype.hideBackdrop = function () {
        if (!this.isBackdropVisible()) {
            return;
        }
        this.backdrop.classList.add('hidden');
        this.backdrop.classList.remove('show');
        this.backdrop.setAttribute('open', 'false');
        document.body.dispatchEvent(new CustomEvent('wr-backdrop-hidden', {
            detail: {
                element: this.backdrop,
                backdrop: this
            }
        }));
    };
    /**
     * @deprecated use the fire function.
     *
     * @see Backdrop.fire
     * @noop
     * @param func
     */
    Backdrop.prototype.addCustomClickHandler = function (func) {
    };
    Backdrop.prototype.keyPressHandler = function (e) {
        this.fire('keypress', e);
        if (e.repeat) {
            return;
        }
        if (['Escape'].includes(e.key)) {
            this.fire('close');
        }
    };
    Backdrop.prototype.clickHandler = function (e) {
        this.fire('click', e);
        this.fire('close');
    };
    Backdrop.getInstance = function () {
        if (Backdrop._instance) {
            return Backdrop._instance;
        }
        return new Backdrop();
    };
    return Backdrop;
}());
exports.Backdrop = Backdrop;
//# sourceMappingURL=Backdrop.js.map